<mat-form-field appearance="outline">
    <mat-label>Buscador</mat-label>
    <input #playerInput type="text" placeholder="Equipo o jugador" matInput
        [matAutocomplete]="auto" (input)="filter(playerInput)" (focus)="filter(playerInput)">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onPlayerSelected($event)">
        <ng-container *ngIf="players.length">
            <mat-optgroup label="Jugadores">
                <mat-option *ngFor="let item of players" [value]="item">
                    <img [src]="item.imgUrl" alt="Jugador" width="24" height="24" style="border-radius: 50%; margin-right: 8px;" />
                    {{ item.name }}
                </mat-option>
            </mat-optgroup>
        </ng-container>

        <ng-container *ngIf="teams.length">
            <mat-optgroup label="Equipos">
                <mat-option *ngFor="let item of teams" [value]="item">
                    <img [src]="item.imgUrl" alt="Equipo" width="24" height="24" style="border-radius: 4px; margin-right: 8px;" />
                    {{ item.name }}
                </mat-option>
            </mat-optgroup>
        </ng-container>
    </mat-autocomplete>
    <mat-icon matSuffix>search</mat-icon>
</mat-form-field>